import { useEffect } from 'react';
import {
  API_SERVER_ERROR_EVENT,
  getActiveSessionRevision,
  subscribeActiveSessionRevision,
} from '@/api/authenticatedClient';
import { toast } from '@/components/ui/sonner';

let nextNotifierId = 0;

const ApiErrorReferenceNotifier = () => {
  useEffect(() => {
    const notifierId = ++nextNotifierId;
    const ownedToasts = new Set();
    const dismissOwned = () => {
      const retired = [...ownedToasts];
      ownedToasts.clear();
      retired.forEach(id => toast.dismiss(id));
    };
    const showReference = (event) => {
      const { reference, revision } = event.detail || {};
      if (typeof reference !== 'string' || !reference
          || !Number.isSafeInteger(revision) || revision !== getActiveSessionRevision()) return;
      // Sonner dismissal is deferred. Neither a new session nor a remounted
      // notifier may reuse the old notification's identity while it settles.
      const id = `server-error-${revision}-${notifierId}-${reference}`;
      ownedToasts.add(id);
      toast.error('Something went wrong', {
        description: `Reference: ${reference}`,
        id,
        onDismiss: () => ownedToasts.delete(id),
        onAutoClose: () => ownedToasts.delete(id),
      });
    };

    const unsubscribe = subscribeActiveSessionRevision(dismissOwned);
    window.addEventListener(API_SERVER_ERROR_EVENT, showReference);
    return () => {
      window.removeEventListener(API_SERVER_ERROR_EVENT, showReference);
      unsubscribe();
      dismissOwned();
    };
  }, []);

  return null;
};

export default ApiErrorReferenceNotifier;
